import React from "react";
import NotFound from "../SharedModule/NotFound"; 
import { formatNumber } from "../../hooks/formatNumber";

const AvailableTyresModal = ({
  isAvailableTyresModalOpen,
  AvailableTyresDetails,
  number,
  setNumber,
  decrement,
  increment,
  setOldOut,
  oldOut,
  setSelectedTyreId,
  createTyreService,
  toggleTireChangeModal,
  baseUrl,
}) => {
  return (
    isAvailableTyresModalOpen && (
      <div
        className="modal fade show"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden={isAvailableTyresModalOpen ? "false" : "true"}
        style={{ display: "block" }}
      >
        <div className="modal-dialog orderDetails-modal" role="document">
          <div className="modal-content">
            <div className="modal-header orderDetails-modalHeader px-4">
              <i
                onClick={toggleTireChangeModal}
                className="fa-solid fa-chevron-left cursor"
              ></i>
              <div className="d-flex align-items-center mx-auto">
                <p className="modal-title orderDetails-modalTitle mx-3 fs-3 fw-semibold">
                  تغيير الكاوتش
                </p>
                <i className="fa-solid fa-rotate fa-xl text-muted"></i>
              </div>
            </div>
            <div className="modal-body orderDetails-modalBody p-3 text-end">
              {AvailableTyresDetails.length > 0 ? (
                <>
                  <h3 className="text-muted my-1">اختر الاطار المناسب ليك</h3>
                  <div className="container my-3">
                    <div className="row d-flex justify-content-end gap-3">
                      {AvailableTyresDetails.map((tyre) => (
                        <div
                          key={tyre.id}
                          className="col-4 d-flex flex-column text-center align-items-center border border-1 rounded-3"
                        >
                          <div className="d-flex w-100 justify-content-end my-2">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id={`flexRadioDefault${tyre.id}`}
                              value={tyre.id}
                              onChange={(e) =>
                                setSelectedTyreId(e.target.value)
                              }
                            />
                          </div>
                          <img
                            src={`${baseUrl}${tyre.icon_url}`}
                            className="w-50 my-1"
                            alt={tyre.name}
                          />
                          <p className="fw-semibold text-muted my-2">
                            {tyre.name}
                          </p>
                          <div className="fw-bold fs-5 d-flex justify-content-end">
                            <p className="mx-1">ج.م</p>
                            <p>{formatNumber(tyre.price)}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mx-1">
                    <div className="d-flex align-items-center justify-content-evenly border border-1 rounded-2">
                      <button
                        className="btn btn-light fs-5"
                        onClick={decrement}
                      >
                        -
                      </button>
                      <input
                        type="text"
                        value={number}
                        readOnly
                        className="text-center border border-0 fs-5 mx-1"
                        style={{ width: "50px" }}
                      />
                      <button
                        className="btn btn-light fs-5"
                        onClick={increment}
                      >
                        +
                      </button>
                    </div>
                    <div>
                      <p className="fs-5 fw-semibold my-0">حدد عدد الاطارات</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-end mb-3 mx-1">
                    <label htmlFor="old" className="fw-semibold fs-5 mx-2">
                      التخلص من الاطارات القديمه
                    </label>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      onChange={(e) => setOldOut(e.target.checked ? 1 : 0)}
                      checked={oldOut === 1}
                      id="old"
                    />
                  </div>
                  <div className="my-2 mx-1">
                    <div className="d-flex align-items-center justify-content-end fw-semibold">
                      <p className="mx-3">
                        القطر :{" "}
                        {AvailableTyresDetails[0].dimension?.rim_diameter}
                      </p>
                      <p className="mx-3">
                        الارتفاع : {AvailableTyresDetails[0].dimension?.height}
                      </p>
                      <p className="mx-3">
                        العرض : {AvailableTyresDetails[0].dimension?.width}
                      </p>
                      <p>: حجم الكاوتش</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-end fw-semibold">
                      <p className="mx-3">العدد : {number}</p>
                      <p className="mx-3">
                        ماركة التصنيع : {AvailableTyresDetails[0].brand?.name}
                      </p>
                      <p>نوع الكاوتش : {AvailableTyresDetails[0].type?.name}</p>
                    </div>
                  </div>
                </>
              ) : (
                <NotFound paragraphText="No Tyres Found For Your Request" />
              )}
            </div>
            <div className="modal-footer mx-auto">
              <button
                type="button"
                className="btn btn-dark px-5 fs-5"
                onClick={createTyreService}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default AvailableTyresModal;
